// 設計 https://qiita.com/Yama-Tomo/items/9cc0836a9cfeb5044105#1-%E3%82%B9%E3%83%86%E3%83%BC%E3%83%88%E3%81%B8%E3%81%AE%E3%82%A2%E3%82%AF%E3%82%BB%E3%82%B9%E3%82%92%E3%82%BF%E3%82%A4%E3%83%97%E3%82%BB%E3%83%BC%E3%83%95%E3%81%AB%E3%81%99%E3%82%8B
// [Vue CLI 3\.0 で TypeScript な Vue\.js プロジェクトをつくってみる \- Qiita](https://qiita.com/nunulk/items/7e20d6741637c3416dcd#43-store)
import { NSOffer } from '@/types/Offer';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@/store';
import { pagePerItems } from '@/types/jobOffer';

export namespace NSStoreEmployeeState {
  export interface filterQuery {
    prefectures: NSOffer.Prefecture['id'][];
  }
}

export type typeFilterQueryConditions = {
  prefectures: NSOffer.Prefecture[];
};

type typeOfferState = {
  prefectures: NSOffer.Prefecture[];
  offers: NSOffer.Offer[];
  filterQuery: NSStoreEmployeeState.filterQuery;
  currentPageNumber: number;
};
const employeeState: typeOfferState = {
  prefectures: window.gmj.employee.prefectures
    ? window.gmj.employee.prefectures
    : [],
  offers: window.gmj.employee.offers ? window.gmj.employee.offers : [],
  filterQuery: {
    prefectures: []
  },
  currentPageNumber: 0
};
const sideJobState: typeOfferState = {
  prefectures: window.gmj.sideJob.prefectures
    ? window.gmj.sideJob.prefectures
    : [],
  offers: window.gmj.sideJob.offers ? window.gmj.sideJob.offers : [],
  filterQuery: {
    prefectures: []
  },
  currentPageNumber: 0
};
const allJobState: typeOfferState = {
  prefectures:
    window.gmj.sideJob.prefectures || window.gmj.employee.prefectures
      ? window.gmj.sideJob.prefectures.concat(window.gmj.employee.prefectures)
      : [],
  offers:
    window.gmj.sideJob.offers || window.gmj.employee.prefectures
      ? window.gmj.employee.offers.concat(window.gmj.sideJob.offers)
      : [],
  filterQuery: {
    prefectures: []
  },
  currentPageNumber: 0
};

const getters: GetterTree<typeOfferState, RootState> = {
  /**
   * 絞り込み条件を適用したアイテムの配列を返す
   * @param state
   */
  filteredOffers(state: typeOfferState): NSOffer.Offer[] {
    const offers = state.offers;
    const filterQuery = state.filterQuery;
    let filteredOffers;

    // 都道府県id基準でfilter
    if (filterQuery.prefectures.length) {
      filteredOffers = offers.filter(offer =>
        filterQuery.prefectures.includes(offer.prefecture.id)
      );
    }

    if (filteredOffers) {
      // console.log(filteredOffers);
      return filteredOffers;
    }

    return offers;
  },
  /**
   * 現在の絞り込み条件を取得する
   * @param state
   */
  filterQuery(state: typeOfferState): NSStoreEmployeeState.filterQuery {
    return state.filterQuery;
  },
  /**
   * 絞り込みに使われる要素を取得する
   * @param state
   */
  filterQueryConditions(state: typeOfferState): typeFilterQueryConditions {
    // 2県ある時に重複を削除する
    const prefectureList = state.prefectures;
    const map = new Map(prefectureList.map(o => [o.id, o]));
    const filteredPrefectureList = Array.from(map.values());
    return {
      prefectures: filteredPrefectureList
    };
  },
  /**
   * 現在のページ番号を返す
   * インクリメントは1から
   * @param currentPageNumber
   */
  currentPageNumber({ currentPageNumber }): number {
    return currentPageNumber + 1;
  },
  /**
   * 絞り込みした後の全件数を返す
   * @return Number
   */
  filteredOffersLength(state, getters): number {
    return getters.filteredOffers.length;
  },
  /**
   * 現在のページの最初のアイテムのindexを返す
   * @param state
   * @param getters
   */
  currentPageItemIndexFrom(state, getters): number {
    // NOTE 要件によっては、swiper上で計算し、emitされてきた値を返すだけ
    return getters.currentPageNumber > 1
      ? (getters.currentPageNumber - 1) * pagePerItems + 1
      : getters.currentPageNumber;
  },
  /**
   * 現在のページの最後のアイテムのindexを返す
   * @param state
   * @param getters
   */
  currentPageItemIndexTo(state, getters): number {
    const pageLastItemIndex = getters.currentPageNumber * pagePerItems;

    return getters.filteredOffersLength > pageLastItemIndex
      ? pageLastItemIndex
      : getters.filteredOffersLength;
  }
};

/**
 * NOTE MutationsはActions以外からの利用禁止
 */
const mutations: MutationTree<typeOfferState> = {
  /**
   * state.filterQueryへのsetter
   * @param state
   * @param filterQuery
   */
  setFilterQuery(
    state: typeOfferState,
    filterQuery: NSStoreEmployeeState.filterQuery
  ) {
    state.filterQuery = { ...filterQuery };
  },
  /**
   * 現在のページ番号を更新する。1ページ目は0
   * @param state
   * @param index
   */
  setCurrentPageNumber(state, index) {
    state.currentPageNumber = index;
  }
};
/**
 * state,commitなどを叩く
 */
const actions: ActionTree<typeOfferState, RootState> = {
  /**
   * state.filterQueryへのsetter。公開API
   * @param state
   * @param filterQuery
   */
  setFilterQuery({ commit }, filterQuery: NSStoreEmployeeState.filterQuery) {
    commit('setFilterQuery', filterQuery);
  },
  setCurrentPageNumber({ commit }, number: number) {
    commit('setCurrentPageNumber', number);
  }
};

//  https://github.com/vuejs/vuex/blob/dev/types/index.d.ts#L111
export const employee: Module<typeOfferState, RootState> = {
  namespaced: true,
  state: employeeState,
  getters,
  mutations,
  actions
};
//  https://github.com/vuejs/vuex/blob/dev/types/index.d.ts#L111
export const sideJob: Module<typeOfferState, RootState> = {
  namespaced: true,
  state: sideJobState,
  getters,
  mutations,
  actions
};
//  https://github.com/vuejs/vuex/blob/dev/types/index.d.ts#L111
export const allJob: Module<typeOfferState, RootState> = {
  namespaced: true,
  state: allJobState,
  getters,
  mutations,
  actions
};
